export default __webpack_public_path__ + "static/media/Illustration_Archery.6ffb6109.svg";